<template>
  <div class="fbsRule">
      <el-dialog :title="$t('other.a2228')" :visible.sync="dialogVisible" width="50%" :close-on-click-modal="false">
		  <el-form :model="ruleForm"  ref="ruleForm" label-width="120px" class="demo-ruleForm">
		    <el-form-item :label="$t('other.a775')" prop="goodType">
		  	  <el-select v-model="ruleForm.goodType" :placeholder="$t('other.a2229')">
		  	  <el-option v-for="item in options"
		  		:key="item.value"
		  		:label="item.label"
		  		:value="item.value">
		  	  </el-option>
		  	</el-select>
		    </el-form-item>
		    <el-form-item :label="$t('other.a2230')" prop="country">
		      <el-select v-model="ruleForm.country" :placeholder="$t('other.a2231')">
		        <el-option :label="$t('other.a1091')" value="TH"></el-option>
		        <el-option :label="$t('other.a1092')" value="MY"></el-option>
		  	    <el-option :label="$t('h5.DSX_index_ph')" value="PH"></el-option>
		  	    <el-option :label="$t('h5.DSX_index_id')" value="ID"></el-option>
                <el-option :label="$t('h5.DSX_index_tw')" value="TW"></el-option>
                <el-option :label="$t('h5.DSX_index_vn')" value="VN"></el-option>
                <el-option :label="$t('h5.DSX_index_bz')" value="BR"></el-option>
                <el-option :label="$t('other.a2232')" value="SG"></el-option>
		      </el-select>
		    </el-form-item>
		    <el-form-item :label="$t('other.a2233')" prop="feeType">
		      <el-select v-model="ruleForm.feeType" :placeholder="$t('other.a2235')">
		        <el-option :label="$t('other.a2153')" value=1></el-option>
		        <el-option :label="$t('other.a1516')" value=0></el-option>
		  	  <el-option :label="$t('other.a2234')" value=2></el-option>
		      </el-select>
		    </el-form-item>
			<el-form-item :label="$t('other.a2236')" prop="fee">
			  <el-input @blur="ruleForm.fee=Number(ruleForm.fee)"  v-model="ruleForm.fee"></el-input>
			</el-form-item>
		      <el-form-item :label="$t('other.a2237')"  prop="consignee">
		        <el-input v-model="ruleForm.consignee"></el-input>
		      </el-form-item>
		  	  <el-form-item :label="$t('other.a899')" prop="phone">
		  	    <el-input v-model="ruleForm.phone"></el-input>
		  	  </el-form-item>
		    <el-form-item :label="$t('other.a2238')" prop="address">
		      <el-input type="textarea" v-model="ruleForm.address"></el-input>
		    </el-form-item>
		 
		  </el-form>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = init()">{{$t('other.a106')}}</el-button>
		    <el-button type="primary" @click="createRule()">{{$t('other.a279')}}</el-button>
		  </span>
		</el-dialog>
    <div>{{$t('other.a2239')}}</div>
    <div>
        <el-button type="primary" @click="dialogVisible=true">{{$t('other.a2240')}}</el-button>
    </div>
    <div>
        <el-table
        border
        :data="rechargeList"
        style="width: 100%">
        <el-table-column
        prop="country"
        :label="$t('other.a481')"
        width="80">
        <template slot-scope="props">
            <span>{{showCountry(props.row.country)}}</span>
        </template>
        </el-table-column>
        <el-table-column
        prop="goodType"
        :label="$t('other.a775')"
        width="80">
        <template slot-scope="props">
            <span>{{showStore(props.row.goodType) }}</span>
        </template>
        </el-table-column>
        <el-table-column
        prop="feeType"
        :label="$t('other.a2233')"
        width="120"
        >
        <template slot-scope="props">
            <span>{{props.row.feeType == 0 ? $t('other.a1516') : props.row.feeType == 1 ? $t('other.a2153') : $t('other.a2241')}}</span>
        </template>
        </el-table-column>
        <el-table-column
        prop="fee"
        :label="$t('other.a2201')"
        width="80"
        >
        </el-table-column>
        <el-table-column
        prop="consignee"
        :label="$t('other.a518')"
        width="100"
        >
        <template slot-scope="props">
            <span>{{props.row.consignee}}</span>
        </template>
        </el-table-column>
        <el-table-column
        prop="phone"
        :label="$t('other.a2242')"
        width="120"
        >
        <template slot-scope="props">
            <span>{{props.row.phone}}</span>
            
        </template>
        </el-table-column>
        <el-table-column
        prop="address"
        :label="$t('other.a517')">
        <template slot-scope="props">
            <span>{{props.row.address}}</span>
            
        </template>
        </el-table-column>
        <el-table-column
        width="180px"
        :label="$t('other.a33')">
        <template slot-scope="props">
            <el-button size="mini" type="primary" >{{$t('other.a93')}}</el-button>
            <el-button size="mini" type="info" @click="cancelRule(props.row.fbsId)">{{$t('other.a312')}}</el-button>
        </template>
        </el-table-column>
    </el-table>
    </div>
  </div>
</template>

<script>
import api from '../../api/moudles/sellerpurchase'
import utils from '../../utils/utils'
export default {
data(){
return{
    rechargeList:[],
    options: [{
    value: 0,
    label: this.$t('other.a2243')
    }, {
    value: 1,
    label: this.$t('other.a2244')
    },{
    value: 2,
    label: this.$t('other.a2245')
    },{
    value: 3,
    label: this.$t('other.a2246')
    },{
    value: 4,
    label: this.$t('other.a2247')
    },{
    value: 5,
    label: this.$t('other.a2248')
    },],
    ruleForm: {
        goodType: '',
        country: '',
        fee:'',
        consignee:'',
        feeType:'',
        phone:'',
        address: ''
    },
    dialogVisible:false,
    userId:null
}
},
created(){
    let userInfo=JSON.parse(localStorage.getItem('userInfo'))
    this.userId=userInfo.userId
    this.getRules()
},
methods:{
    getRules(){
        api
        .getFbsRules({
            userId:this.userId,
        })
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        this.rechargeList=res.data
        }else{
        this.$message.warning(res.msg)
        }
        })
    },
    createRule(){
        console.log('rule',this.ruleForm);
        this.ruleForm.userId=this.userId
        api
        .addFbsRules(this.ruleForm)
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        this.$message.success(this.$t('other.a2249'))
        this.getRules()
        this.dialogVisible=false
        }else{
        this.$message.warning(res.msg)
        }
        })
    },
    cancelRule(id){
        this.$confirm(this.$t('other.a2098'), this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a145'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {
        api
        .deleteRule({fbsId:id})
        .then(res => {
            if(res.code === 200) {
                this.$message.success(this.$t('other.a2250'))
                this.rechargeList.forEach((p,index) => {
                    if(p.fbsId == id) {
                        this.rechargeList.splice(index,1)
                    }
                })
            }
        })
        
        })
    },
    showCountry(id){
				return utils.conversionCountryName(id)
			},
			
			showStore(id){
				let arr=this.options.filter(p => {
					if(p.value == id) {
						return p
					}
				})
				console.log(arr)
				return arr[0].label
			},
}
}

</script>
<style lang="scss" scoped>

</style>